/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

class Navbar extends HTMLElement {
  constructor () {
    super()

    this.handleDropdownsBackdrop()
    this.handleHeaderReveal()
    this.adjustOffcanvasMenu()
  }

  adjustOffcanvasMenu () {
    const offcanvasMenu = document.querySelector('#offcanvas-menu')
    const navbarMobile = document.querySelector('#navbar-mobile')

    offcanvasMenu?.addEventListener('show.bs.offcanvas', () => {
      const navbarSpacing = document.querySelector('#navbar-mobile').getBoundingClientRect().bottom
      offcanvasMenu.style.height = `${window.innerHeight - navbarSpacing}px`

      navbarMobile.querySelector('.svg-icon-menu')?.classList.add('svg-icon-menu-close')
    })

    offcanvasMenu?.addEventListener('hide.bs.offcanvas', () => {
      navbarMobile.querySelector('.svg-icon-menu')?.classList.remove('svg-icon-menu-close')
    })
  }

  handleHeaderReveal () {
    const menuRow = document.getElementById('navbar-menu-row')
    if (!menuRow) return

    const hide = () => {
      menuRow.style.maxHeight = '0px'
      menuRow.style.opacity = '0'
      menuRow.style.paddingTop = '0'
      menuRow.style.paddingBottom = '0'
      menuRow.style.pointerEvents = 'none'
    }

    const show = () => {
      menuRow.style.maxHeight = '80px'
      menuRow.style.opacity = '1'
      menuRow.style.paddingTop = ''
      menuRow.style.paddingBottom = ''
      menuRow.style.pointerEvents = ''
    }

    let isHidden = false
    let ticking = false
    const hideAt = 120
    const showAt = 60

    const update = () => {
      const y = window.scrollY

      // Use hysteresis so the sticky header height change does not
      // immediately retrigger the opposite state near the threshold.
      if (!isHidden && y > hideAt) {
        hide()
        isHidden = true
      } else if (isHidden && y < showAt) {
        show()
        isHidden = false
      }

      ticking = false
    }

    window.addEventListener('scroll', () => {
      if (ticking) return
      ticking = true
      window.requestAnimationFrame(update)
    }, { passive: true })
  }

  handleDropdownsBackdrop () {
    this.querySelectorAll('#navbar-desktop .dropdown-toggle').forEach(dropdown => {
      dropdown.addEventListener('hidden.bs.dropdown', () => {
        if (!document.querySelector('#navbar-desktop .dropdown-toggle.show')) {
          document.body.classList.remove('navbar-dropdown-open')
        }
      })
      dropdown.addEventListener('show.bs.dropdown', () => {
        document.body.classList.add('navbar-dropdown-open')
      })
    })
  }
}
customElements.define('navbar-wrapper', Navbar)
